import { render, staticRenderFns } from "./FabMenu.vue?vue&type=template&id=864c1bec&scoped=true&"
import script from "./FabMenu.vue?vue&type=script&lang=js&"
export * from "./FabMenu.vue?vue&type=script&lang=js&"
import style0 from "./FabMenu.vue?vue&type=style&index=0&id=864c1bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864c1bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
